import Styles from './HandbookSettings.module.scss'
import { HandbookV2 } from 'types'
import { useDatabaseMode } from '../hooks/useDatabaseMode'
import { Button } from 'components/Button'

interface Props {
  handbook: HandbookV2
}

export const DatabaseModeRow = ({ handbook }: Props) => {
  const { databaseMode, toggleDatabaseMode } = useDatabaseMode(handbook)
  const label = databaseMode ? 'Convert to Folder' : 'Convert to Database'
  const subLabel = databaseMode
    ? 'Convert this database to a folder optimized for sharing with your team.'
    : 'Convert this folder to a database to organize your project. Sort, filter, and group by customizable properties and create multiple views.'

  return (
    <div className={Styles.row}>
      <div>
        <div className={Styles.label}>{label}</div>
        <div className={Styles.subLabel}>{subLabel}</div>
      </div>
      <div className={Styles.toggle} onClick={toggleDatabaseMode} data-testid="toggle-database-mode">
        <Button variant="secondary" size="md" onPress={toggleDatabaseMode} data-testid="toggle-database-mode-button">
          Convert
        </Button>
      </div>
    </div>
  )
}
